import type { TimerWidgetData } from '@web/widgets/timer/type';

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { WebBaseViewComponent } from '@web/widgets/common/abstract/web-base-view.component';

import { SpTimerComponent } from '@components/sp-timer';
import { getStyles } from './timer-view.component.styles';

@Component({
    selector: 'web-timer-view',
    templateUrl: './timer-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpTimerComponent, AsyncPipe],
})
export class TimerViewComponent extends WebBaseViewComponent<TimerWidgetData> {
    protected getStyles = getStyles;
}
